<template>
  <div :class="['w3-row', 'definition-wrapper', 'image', definition.id, {'error_validate': mandatoryValidation}]">
    <div v-if="!signature" class="image">
      <div :class="['w3-col', 'image', {'languageImage': (isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable)}]">
        <transition name="fade" mode="out-in">
          <div v-if="imageValue !== ''">
            <img :src="imageValue" :style="styleCss" >
            <i v-if="isEditableImage()" class="sherpa-icon icon-trash" @click="deleteImage()"></i>
          </div>
          <div v-else class="no_image">
            <i class="sherpa-icon icon-imagen"></i>
            <span> {{ getLang('noImage') }} </span>
          </div>
        </transition>
      </div>
      <div v-if="(isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable)" :class="['w3-rest', 'tiny-rest', 'languageSelectorOrTask', {'no_imatge' : imageValue === ''}]">
        <definition-multilanguage v-if="isMultiLanguage() && showMultilanguage"
          :definition="definition" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
          @newLanguageSelected="newLanguageSelected" @copy="copy"
        />
        <definition-task
          v-if="isEditableImage()"
          :definition="definition"
          :object="object"
          :definitionObject="definitionObject"
          :definitionContentId="definitionContentId"
          :repeatableGroupCode="getImageCode()"
          :languageSelected='languageSelected'
          :language="language"
          :authorization="authorization"
          :type="type"
          :visuals="visuals"
          :apiparams="apiparams"
          :callTask="callTask"
          @refreshDefinition="taskValueChanged"
          @refreshDefinitionContent="refreshDefinitionContent"
        />
      </div>
    </div>

    <!-- Signature component -->
    <div v-else-if="showSignature" class="signature">
      <div v-if="editable">
        <!--
        <VueSignaturePad
          :width="getSignatureWidth()"
          :height="getSignatureHeight()"
          ref="signaturePad"
          :options="{ onBegin, onEnd }"
        />
        -->
        <span class="clear-signature" @click="clearSignature">
          <i class="fa fa-trash"></i> {{ getLang('delete') }}
        </span>
      </div>
      <img v-else-if="imageValue !== ''" :src="imageValue" class="no-editable-signature" />
    </div>
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../language'
// import VueSignaturePad from 'vue-signature-pad'

export default {
  name: 'definition-image',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'signature',
    'callTask',
    'styleCss'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask // ,
    // VueSignaturePad
  },
  data () {
    return {
      imageValue: '',
      translating: false,
      showSignature: false
    }
  },
  methods: {
    // 1.1. Launch validate mandatory event on change
    taskValueChanged (object) {
      if (this.isMultiLanguage()) {
        this.imageValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      } else {
        this.imageValue = object.textValue
      }
      this.setObjectImageValue(object)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    setImageValue (languageSelected) {
      if (!this.isMultiLanguage() && this.object.textValue) {
        this.imageValue = this.object.textValue
      } else if (languageSelected) {
        this.setLanguageImageValue(languageSelected)
      }
    },
    setLanguageImageValue (languageSelected) {
      this.imageValue = transport.methods.getLanguageValue(this.object, languageSelected.key)
    },
    validateImageFormat () {
      var format = null
      if (this.isMultiLanguage()) {
        format = transport.methods.getLanguage(this.languageSelected.key, this.definition).format
      } else {
        format = this.definition.validation.format
      }
      this.validation = transport.methods.validateImageFormat(this.definition, format, this.imageValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('imageFormatError', moment().valueOf(), this.validation, format)
      }
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    setObjectImageValue (object) {
      if (this.isMultiLanguage()) {
        if (object) {
          this.object.languageValue = object.languageValue
        }
        this.object = transport.methods.setLanguageValue(this.object, this.imageValue, this.languageSelected.key)
      } else {
        this.object.textValue = this.imageValue
      }
    },
    getLang (key) {
      return language(this.language, key)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    copy (fromLanguage) {
      if (this.imageValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.copyLanguage(fromLanguage, 0, self.object.languageValue)
        }, 500)
      }
    },
    copyLanguage (fromLanguage, index, languages) {
      if (index < languages.length) {
        var language = this.object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          this.object = transport.methods.setLanguageValue(this.object, this.imageValue, language.key)
        }
        this.copyLanguage(fromLanguage, ++index, languages)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    getImageCode () {
      var result = this.repeatableGroupCode
      if (!result) {
        var authVars = this.authorization.split(' ')
        // Segon paràmetre del bearer token "-" timestamp
        var sha256 = require('js-sha256')
        result = sha256(authVars[1] + '-' + moment().valueOf())
        this.$emit('refreshRepeatableGroupCode', result)
      }
      return result
    },
    clearSignature () {
      this.$refs.signaturePad.clearSignature()
      this.saveSignatureData()
    },
    onBegin (event) {
    },
    onEnd (event) {
      this.saveSignatureData()
    },
    saveSignatureData () {
      const { data } = this.$refs.signaturePad.saveSignature('image/svg+xml')
      this.imageValue = data
      if (!data) {
        this.imageValue = ''
      }
      this.setObjectImageValue(this.object)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    getSignatureWidth () {
      var result = this.signature.width
      if (!result) {
        result = '500px'
      } else {
        if (result.substring(result.length - 1) === '%') {
          var percentStr = result.substring(0, result.length - 1)
          var percent = parseInt(percentStr)
          var offsetWidth = this.$parent.$el.offsetWidth
          result = ((offsetWidth / 100) * percent) + 'px'
        }
      }
      return result
    },
    getSignatureHeight () {
      var result = this.signature.height
      if (!result) {
        result = '500px'
      } else {
        if (result.substring(result.length - 1) === '%') {
          var percentStr = result.substring(0, result.length - 1)
          var percent = parseInt(percentStr)
          var offsetHeight = this.$parent.$el.offsetHeight
          result = ((offsetHeight / 100) * percent) + 'px'
        }
      }
      return result
    },
    deleteImage () {
      this.imageValue = ''
      this.setObjectImageValue(this.object)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    isEditableImage () {
      return this.definition.task && this.definition.task.length > 0 && this.editable
    }
  },
  mounted () {
    this.setImageValue(this.languageSelected)
    if (this.signature) {
      this.showSignature = true
      if (this.imageValue) {
        this.$refs.signaturePad.fromDataURL(this.imageValue)
      }
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch image format validation
        this.validateImageFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.isMultiLanguage()) {
        this.setLanguageImageValue(languageSelected)
      }
    },
    object (object) {
      this.setImageValue(this.languageSelected)
    }
  }
}
</script>

<style lang="scss">
  .languageImage {
    float: left;
    width: calc(100% - 110px);
    overflow: hidden;
    border-radius: 5px;
    text-align: center;

    img {
      max-width: 100%;
    }
  }

  .definition-wrapper.image {
    .languageSelectorOrTask {
      float: right;
      min-width: 108px;

      .language {
        max-width: 151px;
        margin-bottom: 10px;

        .multiselect {
          float: left;
          width: auto;

          .multiselect__tags {
            width: 105px;
          }

          .multiselect__tags,
          .multiselect__single,
          .multiselect__input {
            background-color: #efefef;
          }
        }
      }

      #uploadFile {
        width: 100%;
      }
    }
    .image {
      img {
        max-height: 120px;
      }
      .icon-trash {
        position: absolute;
        top: 2px;
        left: 0;
        background-color: #edf118;
        padding: 6px 5px 0;
        color: #000;
        cursor: pointer;
        transition: all 0.2s ease-in;
        border: 1px dotted #000;

        &:before {
          font-size: 20px;
        }

        &:hover {
          color: #999;
        }
      }
    }
  }
  .signature {
    color: #999;
    font-size: 12px;

    .clear-signature {
      cursor: pointer;
      padding: 5px 10px;
      display: block;

      i {
        color: #cecece;
        font-size: 16px;
        transition: all 0.2s ease-in;
      }

      &:hover {
        i {
          color: #b0b0b0;
        }
      }
    }

    canvas {
      border: dashed 2px #e8e8e8;
      border-radius: 2px;
    }

    .no-editable-signature {
      width: 100%;
    }
  }
</style>

<style lang="scss" scoped>
  .no_image {
    position: relative;
    width: calc(100% - 5px);
    min-height: 160px;
    border: 2px dashed #cfcfcf;
    background-color: #efefef;

    i {
      position: absolute;
      top: 45px;
      right: 0;
      left: 0;
      text-align: center;
      font-size: 2.5em;
      color: #cfcfcf;
    }

    span {
      position: absolute;
      top: 95px;
      right: 0;
      left: 0;
      font-size: 12px;
      color: #cfcfcf;
      text-align: center;
      font-weight: 900;
      padding: 0 2px;
      font-style: italic;
    }
  }
</style>
